import React from 'react';
import { twMerge } from 'tailwind-merge';
import { TicketKey } from 'flow/types/EntityKeys';
import TicketHeader from './TicketHeader';
import TicketBackButton from './TicketBackButton';

interface Props {
    ticketKey: TicketKey;
}

const TicketOverviewNavTitle = ({ ticketKey }: Props) => (
    <div
        className={twMerge(
            'flex h-16 items-center justify-between gap-x-3 px-4',
        )}
    >
        <TicketBackButton />
        <div className="flex w-full flex-1 justify-between">
            <TicketHeader ticketKey={ticketKey} />
        </div>
    </div>
);

export default TicketOverviewNavTitle;
